










































































import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import deepEqual from 'deep-equal';
import { trackGroupMessageAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { UserAvatarStore, UserStore } from '@front-app/store/singletons/User';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { Size } from '@front-app/components/constants';
import { getUsername } from '@front-app/util/user';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { NoteMessage, NoteMeta } from '@front-app/services/NoteApi/NoteModels';
import { Content } from '@front-app/services/GroupsApi/DiscussionModel';
import UserLink from '../buttons/UserLink.vue';
import LoaderState from '../LoaderState.vue';
import NotePages from './NotePages.vue';
import FullWidthPanelRow from '../modals/FullWidthPanelRow.vue';
import NoteContextHeader from './NoteContextHeader.vue';
import DenseUserList from '../cards/DenseUserList.vue';
import NoteActionMenu from './NoteActionMenu.vue';

export default defineComponent({
	components: {
		UserLink,
		UserAvatar,
		NotePages,
		LoaderState,
		FullWidthPanelRow,
		NoteContextHeader,
		DenseUserList,
		NoteActionMenu,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		metadata: {
			type: Object as PropType<NoteMeta>,
			required: true,
		},
		messages: {
			type: Array as PropType<NoteMessage[]>,
			required: true,
		},
		discussion: {
			type: Object as PropType<Content>,
			required: true,
		},
		deeplinkNoteMessageId: {
			type: String,
			default: '',
		},
		isLoading: Boolean,
		isSendingInvitations: Boolean,
	},
	setup(props, ctx) {
		const trackActionProps = computed(() => [props.groupId, props.metadata.noteId]);
		const trackView = () => trackGroupMessageAction(props.groupId, props.metadata.noteId, GroupAuditAction.READ_NOTE_PAGE);
		watch(trackActionProps, (curr, prev) => {
			if (deepEqual(curr, prev) || !props.groupId || !props.metadata.noteId) {
				return;
			}
			trackView();
		}, { immediate: true });

		const { getPartial: getUser } = UserStore.getInstance();
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		const verifyLeave = () => {
			const message = ctx.root.$t('note-view.confirm-leave') as unknown as string;
			/* eslint-disable-next-line no-alert */
			if (window.confirm(message)) {
				ctx.emit('leave');
			}
		};

		return {
			trackView,
			verifyLeave,
			getUser,
			getUsernameInternal,
			Size,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
		};
	},
});
